import React from 'react';
import PropTypes from 'prop-types';
import { convertLocalToUtcDate, formatDateTime } from 'library/time';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Inner } from 'components/Page';
import config from './config';

/*
 ** @description Prepare data for api
 ** @param props Object assessor, user, auto_expire, awarded_date, competency, expiry_date, scheduled
 ** @return data object
 */
const handlePrepareData = ({
  assessor, user_id, auto_expire, awarded_date, competency, expiry_date, scheduled
}) => ({
  assessor,
  auto_expire,
  user_id,
  competency_id: competency.key,
  scheduled: formatDateTime(convertLocalToUtcDate(scheduled)),
  awarded_date: formatDateTime(convertLocalToUtcDate(awarded_date)),
  expiry_date: formatDateTime(convertLocalToUtcDate(expiry_date))
});

const UserCompetencies = ({ objectId, permissions }) => (
  <Inner
    canAdmin={permissions.CanAdminUsers()
      .hasPermissions()}
    config={{
      ...config,
      list: {
        ...config.list,
        filters: {
          user__id: [objectId]
        },
        filterSettings: {
          ...config.list.filterSettings,
          parent: objectId
        }
      },
      detail: {
        ...config.detail,
        parent: {
          user_id: objectId
        }
      }
    }}
    defaultSize="200px"
    messaging={{
      delete: {
        disabled: () => 'Item Disabled.',
        failure: error => `Delete Failed. ${error}`,
        success: () => 'Delete Successful.'
      },
      save: {
        failure: () => 'Saving failed',
        success: () => 'Saving was successful'
      }
    }}
    onPrepareData={handlePrepareData}
    reducer={{
      item: REDUCER_KEY.userCompetency,
      list: REDUCER_KEY.userCompetencies
    }}
    scroll={{
      x: 1200,
      y: '100%'
    }}
  />
);

UserCompetencies.propTypes = {
  objectId: PropTypes.number,
  permissions: PropTypes.object.isRequired
};

UserCompetencies.defaultProps = {
  objectId: null
};

export default UserCompetencies;
